import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ImageEnum } from '../../utils/image.enum';
import { PRIVACY_POLICY_DATA } from './privacy-policy.data';

@Component({
  selector: 'app-privacy-policy',
  imports: [CommonModule, RouterModule],
  templateUrl: './privacy-policy.html',
  styleUrl: './privacy-policy.css',
})
export class PrivacyPolicyComponent {
  protected readonly imageEnum = ImageEnum;
  protected readonly privacyPolicyData = PRIVACY_POLICY_DATA;
}
